import { useState } from 'react';
import type { ScheduleCData } from '@/api/hooks/useScheduleC';
import { ScheduleAmount, ScheduleCLineRow } from './ScheduleCLineRow';

export function ScheduleCLineTable({ lines, computedLine28 }: { lines: ScheduleCData['lines']; computedLine28: ScheduleCData['computed_line_28'] }) {
  const [expandedLine, setExpandedLine] = useState<string | null>(null);
  const renderLine = (line: ScheduleCData['lines'][number]) => (
    <ScheduleCLineRow
      key={line.tax_line}
      line={line}
      expanded={expandedLine === line.tax_line}
      onToggle={() => setExpandedLine((current) => current === line.tax_line ? null : line.tax_line)}
    />
  );
  return (
    <div className="overflow-hidden rounded-[10px] border border-border bg-card">
      <div className="grid grid-cols-[42px_minmax(0,1fr)_64px_100px_100px] gap-2 px-3 py-2 text-[11px] uppercase tracking-wide text-muted-foreground">
        <span>Line</span><span>Description</span><span className="text-right">Rows</span><span className="text-right">Recorded</span><span className="text-right">Deductible</span>
      </div>
      <div className="bg-muted/40 px-3 py-1 text-xs text-muted-foreground">Part I · Income</div>
      {lines.filter((line) => line.part === 'I').map(renderLine)}
      <div className="bg-muted/40 px-3 py-1 text-xs text-muted-foreground">Part II · Expenses</div>
      {lines.filter((line) => line.part === 'II').map(renderLine)}
      <div className="grid min-h-12 grid-cols-[42px_minmax(0,1fr)_64px_100px_100px] items-center gap-2 border-t border-border px-3 text-sm font-semibold">
        <span className="font-mono text-muted-foreground">28</span><span>{computedLine28.label} · computed lines only</span><span /><span className="text-right"><ScheduleAmount value={computedLine28.recorded} /></span><span className="text-right"><ScheduleAmount value={computedLine28.deductible} /></span>
      </div>
    </div>
  );
}

export default ScheduleCLineTable;
